import { render, staticRenderFns } from "./CulvertInfoDialog.vue?vue&type=template&id=52971f53&scoped=true&"
import script from "./CulvertInfoDialog.vue?vue&type=script&lang=ts&"
export * from "./CulvertInfoDialog.vue?vue&type=script&lang=ts&"
import style0 from "./CulvertInfoDialog.vue?vue&type=style&index=0&id=52971f53&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52971f53",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
